import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

/**
 * AppLayout — Layout compartido para todas las rutas protegidas.
 * El Sidebar vive aquí y NUNCA se desmonta al navegar entre páginas.
 * Cada página hijo (Outlet) solo renderiza su contenido principal.
 */
function AppLayout() {
    return (
        <div className="layout">
            <Sidebar />
            <Outlet />
        </div>
    );
}

export default AppLayout;